import { PREFILL_USER_FORM_TYPE } from '@components-member/psp/withdrawal/plugins/BasePluginWithdrawal/components/BankAccountRedirectButton/constants';
import { CONSTANTS } from 'components/shared/constants';
import { CURRENCY } from 'global.enums';
import { IPSPInfo } from './pspInfo.interface';

export const getEmptyPspInfo = (): IPSPInfo => {
  return {
    currencies: [],
    exchange: [],
    exchangeRatesToDisplay: [],
    amount: {
      min: 0,
      max: 0,
      currency: CURRENCY.USD,
    },
    operationFee: {
      feeBrackets: [],
      feeCurrency: CURRENCY.USD,
      minFee: 0,
      maxFee: 0,
      skipOptions: {
        operationAmount: null,
        operationAmountComparison: 'Greater',
      },
    },
    operationFeeSkipInfo: {
      feeWillAlwaysBeSkipped: false,
    },
    data: null,
    depositAdminAction: CONSTANTS.DEPOSIT_ADMIN_ACTION.NONE,
    financialIdentityType: null,
    isHideExchangeRate: false,
    bankAccounts: [],
    digitalWalletAccounts: [],
    cards: [],
    cryptoWalletAccounts: [],
    id: 0,
    createUserFinancialIdentityType: PREFILL_USER_FORM_TYPE.NONE,
    userNameAliases: [],
    allowSelectingBeneficiaryName: false,
    storeLocallyNewlyCreatedAccountHolderNames: false,
    operationTutorial: {
      isEnabled: false,
      tutorialVideos: [],
    },
    operationTip: {
      isEnabled: false,
      position: null,
      tips: [],
    },
    requireBankDetails: null,
    consents: [],
  };
};
